module.exports = __webpack_public_path__ + "img/4.18436d4c.png";